import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';

import { DefaultIndexDoc } from '@app/graphql';
import { CONSTANTS } from '@app/constants';
import { PlayerService } from '@app/player';


@Component({
  selector: 'app-video-card',
  templateUrl: './video-card.component.html',
  styleUrls: ['./video-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoCardComponent implements OnInit {

  @Input() article!: DefaultIndexDoc;

  public baseUrl = CONSTANTS.baseUrl;
  public isPlayingOnPage$ = this.player.isPlayingOnPage$;

  constructor(
    private player: PlayerService
  ) {}

  ngOnInit(): void {}

  public playVideo = (article: DefaultIndexDoc): void => {
    this.player.setScrollIntoView('top');
    this.player.playVideo(article);
  };

  public getSrc = (article: DefaultIndexDoc): string => 'https://vumbnail.com/' + article.field_video_id + '.jpg';

  public getPlayBtnLabel = (state: boolean): string => {
    return state ? 'video se přehrává' : 'spustit video';
  }
}
